import { createRouter, createWebHistory } from "vue-router";
import { h, resolveComponent } from "vue";
import moment from "moment";

import { authenticatedUser } from "utils/auth";

import SignIn from "views/sign-in/SignIn.vue";

import ErrorPage from "views/errors/ErrorPage.vue";
import NotFound from "views/errors/NotFound.vue";
import SessionExpired from "views/errors/SessionExpired.vue";
import store from "../store";

import {
  SCREEEN_STATUS_CD,
} from "../models/screen-status";

const utilState = require("utils/state");
const utilAuth = require("utils/auth");

// Container
const ContainerNoSignIn = () => import("containers/ContainerNoSignIn.vue");
const Container = () => import("containers/ContainerSignIn.vue");

const ContainerDownload = () => import("containers/ContainerDownload.vue");

const MonitoringDeviceCreate = () => import("views/monitoring-devices/Create.vue");
const MonitoringDeviceList = () => import("views/monitoring-devices/List.vue");
const MonitoringDeviceUpdate = () => import("views/monitoring-devices/Update.vue");

const MonitoringTargetsCreate = () => import("views/monitoring-targets/Create.vue");
const MonitoringTargetsList = () => import("views/monitoring-targets/List.vue");
const MonitoringTargetsDetail = () => import("views/monitoring-targets/Detail.vue");
const MonitoringTargetsUpdate = () => import("views/monitoring-targets/Update.vue");

const NotificationRecipientList = () => import("views/notification-recipients/List.vue");

const BillingsList = () => import("views/billings/List.vue");
const BillingsInvoice = () => import("views/billings/Invoice.vue");
const BillingsReceipt = () => import("views/billings/Receipt.vue");

const ServiceAccount = () => import("views/service-account/Index.vue");
const ServiceAccountUpdate = () => import("views/service-account/Update.vue");

const SignUpSendAuthCode = () => import("views/sign-up/SendAuthCode.vue");
const SignUpCheckAuthCode = () => import("views/sign-up/CheckAuthCode.vue");
const SignUpForm = () => import("views/sign-up/Form.vue");

// パスワードリセット
const ResetPasswordSendAuthCode = () => import("views/reset-password/SendAuthCode.vue");
const ResetPasswordCheckAuthCode = () => import("views/reset-password/CheckAuthCode.vue");
const ResetPasswordResetForm = () => import("views/reset-password/ResetForm.vue");

export const routes = [
  {
    path: "/",
    redirect: "/monitoring-targets",
    name: "TopPage",
    component: Container,
    meta: { requiresAuth: true },
    children: [
      {
        path: "monitoring-targets",
        name: "MonitoringTargets",
        component: {
          render() {
            return h(resolveComponent("router-view"));
          },
        },
        children: [
          {
            path: "form",
            name: "MonitoringTargetsCreate",
            component: MonitoringTargetsCreate,
          },
          {
            path: "",
            name: "MonitoringTargetsList",
            component: MonitoringTargetsList,
          },
          {
            path: ":id",
            name: "MonitoringTargetsDetail",
            component: MonitoringTargetsDetail,
          },
          {
            path: ":id/edit",
            name: "MonitoringTargetsUpdate",
            component: MonitoringTargetsUpdate,
          },
        ],
      },
      {
        path: "monitoring-devices",
        name: "MonitoringDevices",
        component: {
          render() {
            return h(resolveComponent("router-view"));
          },
        },
        children: [
          {
            path: "/monitoring-devices",
            name: "MonitoringDeviceList",
            component: MonitoringDeviceList,
          },
          {
            path: "/monitoring-devices/create",
            name: "MonitoringDeviceCreate",
            component: MonitoringDeviceCreate,
          },
          {
            path: "/monitoring-devices/edit/:id",
            name: "MonitoringDeviceUpdate",
            component: MonitoringDeviceUpdate,
          },
        ],
      },
    ],
  },
  {
    path: "/service-account",
    name: "ServiceAccount",
    component: Container,
    children: [
      {
        path: "",
        name: "ServiceAccountIndex",
        component: ServiceAccount,
        meta: { requiresAuth: true },
      },
      {
        path: "edit",
        name: "ServiceAccountUpdate",
        component: ServiceAccountUpdate,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/notification-recipients/",
    name: "NotificationRecipients",
    component: Container,
    children: [
      {
        path: "",
        name: "NotificationRecipientsList",
        component: NotificationRecipientList,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/billings/",
    name: "Billings",
    component: Container,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "BillingsList",
        component: BillingsList,

      },
    ],
  },
  {
    path: "/download/",
    name: "Download",
    component: ContainerDownload,
    meta: { requiresAuth: true },
    children: [
      {
        path: "billing/:id/issue-invoice",
        name: "BillingsInvoice",
        component: BillingsInvoice,
      },
      {
        path: "billing/:id/issue-receipt",
        name: "BillingsReceipt",
        component: BillingsReceipt,
      },
    ],
  },
  {
    path: "/sign-in",
    name: "SignIn",
    component: ContainerNoSignIn,
    children: [
      {
        path: "",
        name: "SignInForm",
        component: SignIn,
      },
    ],
  },
  {
    path: "/sign-up",
    name: "SignUp",
    component: ContainerNoSignIn,
    children: [
      {
        path: "",
        name: "SignUpSendAuthCode",
        component: SignUpSendAuthCode,
      },
      {
        path: "email-validation",
        name: "SignUpEmailValidation",
        component: SignUpCheckAuthCode,
      },
      {
        path: "entryform",
        name: "SignUpForm",
        component: SignUpForm,
      },
    ],
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ContainerNoSignIn,
    children: [
      {
        path: "send",
        name: "ResetPasswordSendAuthCode",
        component: ResetPasswordSendAuthCode,
      },
      {
        path: "vefify",
        name: "ResetPasswordCheckAuthCode",
        component: ResetPasswordCheckAuthCode,
      },
      {
        path: "form",
        name: "ResetPasswordResetForm",
        component: ResetPasswordResetForm,
      },
    ],
  },
  // エラーページをまとめる
  {
    path: "/error/:errorId",
    name: "ErrorPage",
    component: ErrorPage,
  },
  {
    path: "/error/session-expired",
    name: "SessionExpired",
    component: SessionExpired,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
  },
];

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  }
  return { top: 0 };
};

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior,
});

const SIGN_IN_PATHS = ["/sign-in/"];

// Authentication status check at screen transition
router.beforeEach(async (to, from, next) => {
  // console.log(to);

  const authUser = await authenticatedUser();

  // ログイン済の状態でログイン画面に遷移 => TOP画面に遷移
  if (authUser && SIGN_IN_PATHS.includes(to.path)) {
    next({
      path: "/monitoring-targets",
    });

  // 認証が必要な画面で未ログイン状態 => ログイン画面へ遷移
  } else if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (!authUser) {
      next({
        path: "/sign-in/",
      });
    } else next();

  //　その他
  } else next();
});

// すべての画面の共通処理
router.beforeResolve(async (to, from, next) => {
  // 共通処理
  // 通知のリセット
  await store.dispatch("notification/resetState");
  // 画面ステータスの初期化
  // TODO: INITIALIZEの仕組みを廃止する
  console.log(to.fullPath);
  if (to.fullPath !== from.fullPath) {
    await store.dispatch(
      "application/updateScreenStatusCd",
      SCREEEN_STATUS_CD.INITIALIZE,
    );
  }

  const authUser = await authenticatedUser();
  // ログイン済
  if (authUser && to.matched.some((route) => route.meta.requiresAuth)) {
    // TODO:
    //  * 一定時間未操作であれば、ログアウト
    //  * 現在の組織が未選択であれば、所属する組織の１番目データを現在の組織にする
    //  * 現在のプロジェクトが未選択であれば、所属する組織の１番目データを現在のプロジェクトにする
    //  * プロジェクトと組織に所属していない状態場合は、エラーページに転送する。

    try {
      // アプリ共通で必要な情報を同期
      await utilState.updateProfileState()
        .catch((err) => {
          // 発生したの内容を、エラー表示のデータに追加
          throw new Error(err);
        });

      await utilState.updateServiceAccountState()
        .catch((err) => {
          // 発生したの内容を、エラー表示のデータに追加
          throw new Error(err);
        });
      const currentServiceAccount = await utilState.currentServiceAccount();
      await utilState.updateAsigProjectState(currentServiceAccount.serviceAccountId)
        .catch((err) => {
          // 発生したの内容を、エラー表示のデータに追加
          throw new Error(err);
        });

      const lastAccessDate = await utilState.getLastAccessDate();
      if (lastAccessDate === null) {
        await utilState.updateLastAccessDate();
      }
      if (moment().diff(lastAccessDate) / (60 * 1000) >= 60) {
        await utilAuth.signOut();
        next({
          path: "/error/session-expired",
        });
      } else {
        await utilState.updateLastAccessDate();
      }
    } catch (err) {
      // TODO: 発生したエラーを画面に反映
    }
    next();

  //　未ログイン
  } else next();
});

// すべてのページで必要な描画に関連しない処理を定義する
router.afterEach(async () => {
  // TODO:
  //  * 最終操作日時、最終アクセスページ・・・storeで管理する
});

export default router;
